<div [ngStyle]="styles"></div>
